import { changeTitle } from '../common';
/* eslint-disable vars-on-top */
const userAgent = navigator.userAgent;
const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1;
const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const isWechat = /MicroMessenger/i.test(userAgent);
// 修改title
// function changeTitle(title) {
//   // eslint-disable-next-line no-unused-vars
//   const body = document.getElementsByTagName('body')[0];
//   document.title = title;
//   const iframe = document.createElement('iframe');
//   iframe.setAttribute('src', 'favicon.ico');
//   // eslint-disable-next-line vars-on-top
//   // eslint-disable-next-line no-var
//   function myfun() {
//     setTimeout(() => {
//       iframe.removeEventListener('load', myfun);
//       document.body.removeChild(iframe);
//     }, 0);
//   }
//   iframe.addEventListener('load', myfun);
//   document.body.appendChild(iframe);
// }
export default function setTitle(title) { // 设置标题  title：字符串
    try {
        if (isWechat) {
            changeTitle(title);
        } else if (isAndroid) {
            if (window.WebViewJavascriptBridge) {
                window.WebViewJavascriptBridge.callHandler(
                    'setTitle', {
                        title,
                    },
                    (responseData) => {
                        console.log(responseData);
                    },
                );
            } else {
                document.addEventListener(
                    'WebViewJavascriptBridgeReady',
                    () => {
                        window.WebViewJavascriptBridge.callHandler(
                            'setTitle', {
                                title,
                            },
                            (responseData) => {
                                console.log(responseData);
                            },
                        );
                    },
                    false,
                );
            }
        } else if (isIOS) {
            window.webkit.messageHandlers.setTitle.postMessage({
                title,
            });
        } else {
            console.log(111);
        }
    } catch (error) {
        changeTitle(title);
    }
}


// WEBPACK FOOTER //
// ./src/utils/bridge/setTitle.js